<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" class="modal-content">
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Packages with Group Discounts</h3>

      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>

  <div class="-modal-body">
    <div class="card bg-soft-light mt-3 mb-4 mx-2" *ngFor="let package of packages">
      <div class="card-header" style="font-weight: 600; font-size: 18px;">
        {{ package.category }} > {{ package.name }}
      </div>
      <div class="card-body">
        <div class="row" *ngFor="let tier of package.groupDiscountTiers.tiers">
          <div class="col-12">
            A discount of {{tier.discountPercentage*100}}% for {{tier.minQuantity}} {{tier.maxQuantity == 999 ? 'or more' : ('- ' + tier.maxQuantity)}} registrants
          </div>
        </div>
      </div>
    </div>
  </div>

  

</div>
